import gql from 'graphql-tag';

export default gql`
  fragment PublicUserProfile on PublicUserProfile {
    id
    full_name
    job_title
    follower_count
    email_address
    location_title
    location {
      id
      title
      block_message
    }
    department_title
    user_type
    user_status
    reach
    karma
    leaderboard_enabled
    image {
      bucket
      key
      width
      height
    }
  }
`;
